<template>

<div>

<section class="kc-elm kc-css-543844 kc_row">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="kc-row-container  kc-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-933501 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="ssc_mltttl  kc-elm kc-css-6259 ">
                  <div class="wr deb derb dea dera none nonea">
                     <h2 class="t1">Our Creative </h2>
                     <h2 class="t2">Team</h2>
                     <p class="t3">We are committed to using fact-based knowledge and our unique brand of innovation to help you dominate the competition. </p>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>



<section class="kc-elm kc-css-3441445 kc_row home_teams">
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr5" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="befbgr6" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr7" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="aftbgr8" data-ssc-svg="" data-ssc-img-s="" data-ssc-img-anim=""></div>
   <div class="kc-row-container">
      <div class="kc-wrap-columns">
         <div class="kc-elm kc-css-5985524 kc_col-sm-12 kc_column kc_col-sm-12">
            <div class="kc-col-container">
               <div class="ssc_carousel template-1 kc-elm kc-css-4738947 kc_tabs group kc-tabs-slider">
                  <div class="owl-carousel owl-theme" style="opacity: 1; display: block;">
                     <div class="owl-wrapper-outer">
                        <div class="owl-wrapper" style="width: 6096px; left: 0px; display: block;">
                           <div class="owl-item" style="width: 381px;">
                              <div id="new-tab" class="kc-elm kc-css-6867367 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class="ssc_team  type8 mo none  kc-elm kc-css-1654485">
                                       <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Frame-56-1.jpg" alt="John Doe Manager" style="-webkit-filter: grayscale(0%);filter: grayscale(0%);" src="../../assets/images/Frame-56-1.jpg"></figure>
                                       <div class="islide">
                                          <div class="content-socials"><a href="#" target="_blank"><i class="fab-facebook-f"></i></a><a href="#" target="_blank"><i class="fab-twitter"></i></a><a href="#" target="_blank"><i class="fab-linkedin-in"></i></a></div>
                                          <div class="posa">
                                             <div class="content-title">John Doe</div>
                                             <div class="content-subtitle">Manager</div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 381px;">
                              <div id="new-tab2" class="kc-elm kc-css-1521174 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class="ssc_team  type8 mo none  kc-elm kc-css-3753862">
                                       <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Frame-56-4.jpg" alt="John Doe Manager" style="-webkit-filter: grayscale(0%);filter: grayscale(0%);" src="../../assets/images/Frame-56-4.jpg"></figure>
                                       <div class="islide">
                                          <div class="content-socials"><a href="#" target="_blank"><i class="fab-facebook-f"></i></a><a href="#" target="_blank"><i class="fab-twitter"></i></a><a href="#" target="_blank"><i class="fab-linkedin-in"></i></a></div>
                                          <div class="posa">
                                             <div class="content-title">John Doe</div>
                                             <div class="content-subtitle">Manager</div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 381px;">
                              <div id="new-tab3" class="kc-elm kc-css-8067266 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class="ssc_team  type8 mo none  kc-elm kc-css-6307974">
                                       <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Frame-56.jpg" alt="John Doe Manager" style="-webkit-filter: grayscale(0%);filter: grayscale(0%);" src="../../assets/images/Frame-56.jpg"></figure>
                                       <div class="islide">
                                          <div class="content-socials"><a href="#" target="_blank"><i class="fab-facebook-f"></i></a><a href="#" target="_blank"><i class="fab-twitter"></i></a><a href="#" target="_blank"><i class="fab-linkedin-in"></i></a></div>
                                          <div class="posa">
                                             <div class="content-title">John Doe</div>
                                             <div class="content-subtitle">Manager</div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 381px;">
                              <div id="new-tab4" class="kc-elm kc-css-6617739 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class="ssc_team  type8 mo none  kc-elm kc-css-1227754">
                                       <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Frame-56-3.jpg" alt="John Doe Manager" style="-webkit-filter: grayscale(0%);filter: grayscale(0%);" src="../../assets/images/Frame-56-3.jpg"></figure>
                                       <div class="islide">
                                          <div class="content-socials"><a href="#" target="_blank"><i class="fab-facebook-f"></i></a><a href="#" target="_blank"><i class="fab-twitter"></i></a><a href="#" target="_blank"><i class="fab-linkedin-in"></i></a></div>
                                          <div class="posa">
                                             <div class="content-title">John Doe</div>
                                             <div class="content-subtitle">Manager</div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 381px;">
                              <div id="new-tab5" class="kc-elm kc-css-1462540 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class="ssc_team  type8 mo none  kc-elm kc-css-5225656">
                                       <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Frame-56-2.jpg" alt="John Doe Manager" style="-webkit-filter: grayscale(0%);filter: grayscale(0%);" src="../../assets/images/Frame-56-2.jpg"></figure>
                                       <div class="islide">
                                          <div class="content-socials"><a href="#" target="_blank"><i class="fab-facebook-f"></i></a><a href="#" target="_blank"><i class="fab-twitter"></i></a><a href="#" target="_blank"><i class="fab-linkedin-in"></i></a></div>
                                          <div class="posa">
                                             <div class="content-title">John Doe</div>
                                             <div class="content-subtitle">Manager</div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 381px;">
                              <div id="new-tab6" class="kc-elm kc-css-1160642 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class="ssc_team  type8 mo none  kc-elm kc-css-8206281">
                                       <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Frame-56-1.jpg" alt="John Doe Manager" style="-webkit-filter: grayscale(0%);filter: grayscale(0%);" src="../../assets/images/Frame-56-1.jpg"></figure>
                                       <div class="islide">
                                          <div class="content-socials"><a href="#" target="_blank"><i class="fab-facebook-f"></i></a><a href="#" target="_blank"><i class="fab-twitter"></i></a><a href="#" target="_blank"><i class="fab-linkedin-in"></i></a></div>
                                          <div class="posa">
                                             <div class="content-title">John Doe</div>
                                             <div class="content-subtitle">Manager</div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 381px;">
                              <div id="new-tab7" class="kc-elm kc-css-7340419 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class="ssc_team  type8 mo none  kc-elm kc-css-315593">
                                       <figure><img class=" ls-is-cached lazyloaded" data-src="../../assets/images/Frame-56-4.jpg" alt="John Doe Manager" style="-webkit-filter: grayscale(0%);filter: grayscale(0%);" src="../../assets/images/Frame-56-4.jpg"></figure>
                                       <div class="islide">
                                          <div class="content-socials"><a href="#" target="_blank"><i class="fab-facebook-f"></i></a><a href="#" target="_blank"><i class="fab-twitter"></i></a><a href="#" target="_blank"><i class="fab-linkedin-in"></i></a></div>
                                          <div class="posa">
                                             <div class="content-title">John Doe</div>
                                             <div class="content-subtitle">Manager</div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div class="owl-item" style="width: 381px;">
                              <div id="new-tab8" class="kc-elm kc-css-5996053 kc_tab ui-tabs-panel kc_ui-tabs-hide kc_clearfix ">
                                 <div class="kc_tab_content">
                                    <div class="ssc_team  type8 mo none  kc-elm kc-css-392261">
                                       <figure><img class="lazyload" data-src="../../assets/images/Frame-56.jpg" alt="John Doe Manager" style="-webkit-filter: grayscale(0%);filter: grayscale(0%);"></figure>
                                       <div class="islide">
                                          <div class="content-socials"><a href="#" target="_blank"><i class="fab-facebook-f"></i></a><a href="#" target="_blank"><i class="fab-twitter"></i></a><a href="#" target="_blank"><i class="fab-linkedin-in"></i></a></div>
                                          <div class="posa">
                                             <div class="content-title">John Doe</div>
                                             <div class="content-subtitle">Manager</div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                     </div>
                     <div class="owl-controls clickable">
                        <div class="owl-pagination">
                           <div class="owl-page active"><span class=""></span></div>
                           <div class="owl-page"><span class=""></span></div>
                        </div>
                        <div class="owl-buttons">
                           <div class="owl-prev">
                              <div class="svg">
                                 <svg width="30" height="18" viewBox="0 0 30 18" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M8.22785 0.771973L9.56414 2.10833L3.61767 8.05487H30V9.94478H3.61767L9.56414 15.8913L8.22785 17.2276L-1.90735e-06 8.99976L8.22785 0.771973Z"></path>
                                 </svg>
                              </div>
                              <span class="t"></span>
                           </div>
                           <div class="owl-next">
                              <span class="t"></span>
                              <div class="svg">
                                 <svg width="30" height="18" viewBox="0 0 30 18" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M21.7721 0.771973L20.4359 2.10833L26.3823 8.05487H0V9.94478H26.3823L20.4359 15.8913L21.7721 17.2276L30 8.99976L21.7721 0.771973Z"></path>
                                 </svg>
                              </div>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</section>

</div>


</template>

<script>
export default {
  name: "Team",
  props: ["title", "subtitle", "header"],
  data() {
    return {
      msg: "Team"
    };
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media all{
*,.kc-col-container,.kc-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-12{width:100%;}
.kc-container{width:100%;max-width:1170px;margin:0 auto;padding-left:15px;padding-right:15px;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc-row-container.kc-container .kc-wrap-columns{margin-left:-15px;margin-right:-15px;clear:both;}
.kc_column{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container{height:100%;}
.kingcomposer div.kc_column{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
.kc-row-container.kc-container .kc-wrap-columns{width:calc(100% + 30px);}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column{width:100%;}
}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus{outline:none;}
section{display:block;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:40px;line-height:52px;text-transform:full-size-kana;text-align:left;margin:20px 0 15px 0;}
p{margin:10px 0 25px 0;}
.page p{line-height:29px;}
*,*:before,*:after{box-sizing:inherit;}
.kc-row-container:after{content:"";display:block;clear:both;}
.kc-col-container>div{position:relative;}
@media screen and (max-width:601px){
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;}
p{margin:10px 0 25px 0;line-height:26px;}
h2{font-family:"Montserrat";color:#222;font-weight:500;font-size:30px;line-height:34px;text-transform:none;text-align:center;margin:20px 0;}
}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
.ssc_mltttl .wr p{margin:0;}
.ssc_mltttl>div{display:block;width:auto;position:relative;}
.deb:before,.dea:after{position:absolute;content:'';display:block;top:0;transition:all 400ms;}
.deb.none:before,.dea.nonea:after{content:none;}
.derb:before,.dera:after{right:0;}
.kc-col-container:after{content:"";display:block;clear:both;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
h2{font-size:30px;line-height:34px!important;}
p.t3{font-size:20px;line-height:26px;padding-top:20px!important;}
}
/*! CSS Used from: Embedded */
.kc-container{max-width:1170px;}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-933501{width:100%;}
}
body.kc-css-system .kc-css-543844{padding-top:80px;z-index:3;}
body.kc-css-system .kc-css-6259{text-align:center;display:inline-block;}
body.kc-css-system .kc-css-6259 .deb:before{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-left:455px;}
body.kc-css-system .kc-css-6259 .deb:after{background-color:#ED7D31;width:7px;height:7px;margin-top:13px;margin-right:455px;}
body.kc-css-system .kc-css-6259 .t1{text-align:center;text-transform:full-size-kana;display:inline;}
body.kc-css-system .kc-css-6259 .t2{color:#ED7D31;display:inline;}
body.kc-css-system .kc-css-6259 .t3{padding-top:17px;padding-right:21%;padding-left:21%;}
@media only screen and (max-width:768px){
body.kc-css-system .kc-css-6259 .deb:before{display:none;}
body.kc-css-system .kc-css-6259 .deb:after{display:none;}
}
@media only screen and (max-width:1024px){
body.kc-css-system .kc-css-933501 .kc-col-container{width:100%;}
}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-543844{background:transparent url(../../assets/images/office-3.jpg) -750px bottom/auto no-repeat scroll;padding-top:15px;}
body.kc-css-system .kc-css-933501 .kc-col-container{padding-right:15px;}
body.kc-css-system .kc-css-933501{margin-left:0%;width:100%;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-543844{padding-top:0px;}
body.kc-css-system .kc-css-6259 .t3{padding-right:15px;padding-left:15px;}
}


@media all{
*,.kc-col-container,.kc-elm{box-sizing:border-box;}
div{display:block;}
.kc-elm{float:left;width:100%;}
.kc_col-sm-12{width:100%;}
.kc-row-container:not(.kc-container){padding-left:0;padding-right:0;width:100%;max-width:100%;}
.kc_row:not(.kc_row_inner){clear:both;float:left;width:100%;}
.kc_column{min-height:1px;position:relative;padding-right:15px;padding-left:15px;float:left;}
.kc_column>.kc-col-container{height:100%;}
.kingcomposer div.kc_column{clear:none;}
.kc-col-container{clear:both;display:block;width:100%;}
@media screen and (min-width:999px){
.kc-row-container .kc-wrap-columns{display:-webkit-flex;display:-ms-flexbox;display:flex;width:100%;flex-wrap:wrap;}
}
@media screen and (max-width:767px){
body.kc-css-system .kc_column{width:100%;}
}
.kc_tabs{margin-bottom:24px;}
.kc_tabs{display:inline-block;width:100%;}
.content-title{margin:25px 0 20px;font-size:20px;text-transform:uppercase;font-weight:700;color:#444;}
.entry-content a{box-shadow:none;}
.content-subtitle{float:left;width:100%;}
[class^="fab-"],[class^="fab-"]:before{font-family:'FontAwesome';font-style:inherit;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;display:inline-block;text-rendering:auto;speak:none;font-weight:400;}
[class^="fab-"],[class^="fab-"]:before{font-family:'FontAwesomeBrands';}
.fab-facebook-f:before{content:"\f39e";}
.fab-linkedin-in:before{content:"\f0e1";}
.fab-twitter:before{content:"\f099";}
*{box-sizing:border-box;}
*:before,*:after{box-sizing:border-box;}
div:focus,i:focus{outline:none;}
figure,section{display:block;}
img{border:0;max-width:100%;}
svg:not(:root){overflow:hidden;}
figure{margin:0 auto;}
i{font-style:italic;}
*,*:before,*:after{box-sizing:inherit;}
img{height:auto;max-width:100%;}
.kc-row-container:after{content:"";display:block;clear:both;}
body .kc_tab_content:after{content:"";display:block;clear:both;}
.owl-theme .owl-controls{margin-top:20px;text-align:center;}
.owl-theme .owl-controls .owl-buttons>div{color:#FFF;display:inline-block;zoom:1;*display:inline;margin:5px;padding:3px 10px;font-size:8px;-webkit-border-radius:30px;-moz-border-radius:30px;border-radius:50px;background:#272727;filter:Alpha(Opacity=50);opacity:.5;}
.owl-theme .owl-controls.clickable .owl-buttons div:hover{filter:Alpha(Opacity=100);opacity:1;text-decoration:none;}
.owl-theme .owl-controls .owl-page{display:inline-block;zoom:1;*display:inline;}
.owl-theme .owl-controls .owl-page span{display:block;width:8px;height:8px;margin:5px 3px;filter:Alpha(Opacity=30);opacity:.3;-webkit-border-radius:20px;-moz-border-radius:20px;border-radius:20px;background:#272727;}
.owl-theme .owl-controls .owl-page.active span,.owl-theme .owl-controls.clickable .owl-page:hover span{filter:Alpha(Opacity=100);opacity:1;}
.owl-carousel .owl-wrapper:after{content:".";display:block;clear:both;visibility:hidden;line-height:0;height:0;}
.owl-carousel{display:none;position:relative;width:100%;-ms-touch-action:pan-y;}
.owl-carousel .owl-wrapper{display:none;position:relative;-webkit-transform:translate3d(0,0,0);}
.owl-carousel .owl-wrapper-outer{overflow:hidden;position:relative;width:100%;}
.owl-carousel .owl-item{float:left;}
.owl-controls .owl-page,.owl-controls .owl-buttons div{cursor:pointer;}
.owl-controls{-webkit-user-select:none;-khtml-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-tap-highlight-color:rgba(0,0,0,0);}
.owl-carousel .owl-wrapper,.owl-carousel .owl-item{-webkit-backface-visibility:hidden;-moz-backface-visibility:hidden;-ms-backface-visibility:hidden;-webkit-transform:translate3d(0,0,0);-moz-transform:translate3d(0,0,0);-ms-transform:translate3d(0,0,0);}
body .owl-theme .owl-controls .owl-page.active span,.owl-theme .owl-controls.clickable .owl-page:hover span{transform:scale(1.3);}
body .owl-theme .owl-controls .owl-buttons>div{opacity:.8;background-color:#474747;font-weight:700;padding:5px 20px;font-size:14px;text-align:center;}
body .owl-theme .owl-controls .owl-buttons>div:hover{opacity:1;}
.owl-theme .owl-controls .owl-page span{transition:all 0.3s;}
.kc-col-container>div{position:relative;}
section{position:relative;}
.befbgr,.befbgr5,.befbgr6{position:absolute;top:0;left:0;width:100%;line-height:0;transition:all 300ms;}
.aftbgr,.aftbgr7,.aftbgr8{position:absolute;bottom:0;left:0;width:100%;line-height:0;transition:all 300ms;}
@media screen and (max-width:1024px){
.befbgr,.befbgr5,.befbgr6,.aftbgr,.aftbgr7,.aftbgr8{overflow:hidden;}
}
.ssc_team{overflow:hidden;position:relative;width:auto;transition:all 400ms ease-in;}
.ssc_team .content-socials a{transition:all 400ms ease-in;}
.ssc_team img{margin-bottom:-8px;transition:all 400ms;}
.ssc_team figure{overflow:hidden;position:relative;}
.ssc_team figure:before{content:"";display:block;position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;z-index:1;}
.ssc_team .content-title{margin:0;}
.ssc_team .content-subtitle{float:none;}
.ssc_team a i{text-decoration:none;}
.ssc_team i{transition:all 200ms;}
.ssc_team .islide{overflow:hidden;transition:all 400ms ease-in;z-index:2;position:relative;}
.ssc_team .islide>div{transition:all 400ms ease-in;}
.ssc_team.type8 .islide{position:absolute;z-index:1;bottom:0;top:0;left:0;width:100%;text-align:center;height:100%;transform:scale(0);}
.ssc_team.type8 .posa{position:absolute;z-index:1;bottom:0;left:0;width:100%;text-align:center;}
.ssc_team.type8:hover .islide{transform:scale(1);}
.ssc_team.type8 .content-title,.ssc_team.type8 .content-subtitle{text-align:left;}
.ssc_team.type8 .content-socials{padding:20px 15px 20px 0;text-align:right;}
.ssc_team.type8 .content-socials a{padding:0;color:#e84265;background-color:rgba(255,255,255,.85);width:40px;height:40px;display:inline-block;margin:0 8px 8px 0;line-height:40px;text-align:center;}
.ssc_team.type8 .content-socials a:hover{background-color:#fff;}
body .owl-carousel:after{content:"";clear:both;display:block;}
.ssc_carousel .owl-theme .owl-controls{margin-top:0;}
.ssc_carousel .owl-theme .owl-controls{position:relative;z-index:3;}
.owl-next,.owl-prev{transition:all 200ms;}
.owl-item:hover{z-index:5;}
.kc-col-container:after{content:"";display:block;clear:both;}
}
/*! CSS Used from: Embedded */
@media (max-width: 479px){
body .owl-theme .owl-controls .owl-buttons > div{padding:0;}
}
/*! CSS Used from: Embedded */
@media only screen and (min-width:1000px) and (max-width:5000px){
body.kc-css-system .kc-css-5985524{width:100%;}
}
.kc-css-3441445 .kc_column{padding-left:0px;padding-right:0px;}
body.kc-css-system .kc-css-3441445{padding-top:45px;}
body.kc-css-system .kc-css-4738947 .owl-page span{background-color:rgba(243, 84, 68, 0.50);width:10px;height:5px;margin-right:5px;margin-left:5px;}
body.kc-css-system .kc-css-4738947 .owl-page.active span,body.kc-css-system .kc-css-4738947 .owl-page:hover span{background-color:#ED7D31;width:20px;height:5px;}
body.kc-css-system .kc-css-4738947 .owl-pagination{margin-top:40px;}
body.kc-css-system .kc-css-4738947 .owl-controls .owl-buttons div{color:#999999;background-color:rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-4738947 .owl-controls .owl-buttons div:hover{color:#ED7D31;background-color:rgba(255, 255, 255, 0);}
body.kc-css-system .kc-css-4738947 .owl-controls .owl-buttons{margin-top:-37px;}
body.kc-css-system .kc-css-4738947 .owl-controls .owl-buttons div svg{width:138px;height:18px;}
body.kc-css-system .kc-css-4738947 .svg{fill:#999999;}
body.kc-css-system .kc-css-4738947 .svg:hover{fill:#ED7D31;}
body.kc-css-system .kc-css-6867367{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-1654485 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-1654485 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-1654485 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-1654485 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-1654485 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-1654485 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-1654485 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-1654485 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-1654485 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-1521174{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-3753862 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-3753862 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-3753862 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-3753862 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-3753862 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-3753862 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-3753862 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-3753862 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-3753862 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-8067266{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-6307974 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-6307974 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-6307974 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-6307974 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-6307974 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-6307974 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-6307974 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-6307974 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-6307974 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-6617739{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-1227754 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-1227754 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-1227754 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-1227754 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-1227754 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-1227754 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-1227754 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-1227754 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-1227754 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-1462540{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-5225656 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-5225656 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-5225656 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-5225656 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-5225656 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-5225656 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-5225656 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-5225656 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-5225656 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-1160642{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-8206281 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-8206281 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-8206281 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-8206281 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-8206281 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-8206281 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-8206281 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-8206281 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-8206281 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-7340419{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-315593 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-315593 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-315593 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-315593 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-315593 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-315593 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-315593 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-315593 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-315593 .content-socials a:hover{background-color:#ffffff;}
body.kc-css-system .kc-css-5996053{padding-right:15px;padding-left:15px;}
body.kc-css-system .kc-css-392261 .islide{border-bottom-right-radius:10px;border-bottom-left-radius:10px;}
body.kc-css-system .kc-css-392261 .content-title{color:#222222;background-color:#f6f7fb;font-family:Catamaran;font-size:20px;font-weight:500;text-transform:none;text-align:center;padding-top:35px;}
body.kc-css-system .kc-css-392261 .content-subtitle{color:#666666;background-color:#f6f7fb;font-size:17px;text-align:center;padding-bottom:35px;}
body.kc-css-system .kc-css-392261 img{border-radius:10px 10px 10px 10px;}
body.kc-css-system .kc-css-392261 .content-socials{float:right;width:50px;margin-right:5%;padding-top:37%;}
body.kc-css-system .kc-css-392261 .content-socials a i{color:#ffffff;}
body.kc-css-system .kc-css-392261 .content-socials a:hover i{color:#ED7D31;}
body.kc-css-system .kc-css-392261 .content-socials a{background-color:#ED7D31;border-radius:50% 50% 50% 50%;}
body.kc-css-system .kc-css-392261 .content-socials a:hover{background-color:#ffffff;}
@media only screen and (max-width:999px){
body.kc-css-system .kc-css-5985524{margin-left:0%;width:100%;}
}
@media only screen and (max-width:479px){
body.kc-css-system .kc-css-5985524{margin-left:0%;width:100%;}
body.kc-css-system .kc-css-4738947 .owl-controls .owl-buttons{margin-top:0px;}
}
/*! CSS Used fontfaces */
@font-face{font-display:swap;font-family:'FontAwesome';src:url(../../assets/fonts/fa-solid-900.eot);src:url("../../assets/fonts/fa-solid-900.eot#iefix") format("embedded-opentype"),url(../../assets/fonts/fa-solid-900.woff2) format("woff2"),url(../../assets/fonts/fa-solid-900.woff) format("woff"),url(../../assets/fonts/fa-solid-900.ttf) format("truetype"),url("../../assets/fonts/fa-solid-900.svg#fontawesome") format("svg");font-weight:400;font-style:normal;}
@font-face{font-display:swap;font-family:'FontAwesomeBrands';font-style:normal;font-weight:400;src:url(../../assets/fonts/fa-brands-400.eot);src:url("../../assets/fonts/fa-brands-400.eot#iefix") format("embedded-opentype"),url(../../assets/fonts/fa-brands-400.woff2) format("woff2"),url(../../assets/fonts/fa-brands-400.woff) format("woff"),url(../../assets/fonts/fa-brands-400.ttf) format("truetype"),url("../../assets/fonts/fa-brands-400.svg#fontawesome") format("svg");}
</style>



// WEBPACK FOOTER //
// src/components/Blocks/Team.vue